import React from 'react';
import { motion } from 'framer-motion';
import { useOrder } from '../../contexts/OrderContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiDollarSign, FiShoppingBag, FiClock, FiTrendingUp } = FiIcons;

const OrderStats = () => {
  const { getTodaysOrders, getTodaysRevenue, getOrdersByStatus } = useOrder();

  const todaysOrders = getTodaysOrders();
  const todaysRevenue = getTodaysRevenue();
  const pendingOrders = getOrdersByStatus('pending');
  const preparingOrders = getOrdersByStatus('preparing');

  const stats = [
    {
      title: "Today's Revenue",
      value: `$${todaysRevenue.toFixed(2)}`,
      icon: FiDollarSign,
      color: 'bg-green-500'
    },
    {
      title: "Today's Orders",
      value: todaysOrders.length,
      icon: FiShoppingBag,
      color: 'bg-blue-500'
    },
    {
      title: 'Pending Orders',
      value: pendingOrders.length,
      icon: FiClock,
      color: 'bg-orange-500'
    },
    {
      title: 'In Progress',
      value: preparingOrders.length,
      icon: FiTrendingUp,
      color: 'bg-purple-500'
    }
  ];

  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
      {stats.map((stat, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: index * 0.1 }}
          className="bg-white rounded-xl shadow-lg p-6"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-warm-brown/70 text-sm font-medium">{stat.title}</p>
              <p className="text-2xl font-bold text-warm-brown mt-1">{stat.value}</p>
            </div>
            <div className={`${stat.color} w-12 h-12 rounded-lg flex items-center justify-center`}>
              <SafeIcon icon={stat.icon} className="text-white text-xl" />
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default OrderStats;